let instance = null;

import FortMarker from '../components/markers/marker';
import ClusterPopup from '../components/popup/cluster-popup';

export default class MarkersService {
    constructor(map, settings) {
        if (!instance) {
            this.map = map;
            this.clusterPopupTimerId;
            this.markersDictionary = {};
            this.markersLayer = null;
            this.clusterPopup = null;
            this.selectedMarker = null;
            this.isMarkersVisible = settings.markersVisibility;
            instance = this;
            this.curZoom = this.map.getZoom();
            this.scales = [
                0.5, // 0
                0.5, // 1
                0.5, // 2
                0.5, // 3
                0.5, // 4
                0.5, // 5
                0.5, // 6
                0.5, // 7
                0.5, // 8
                0.5, // 9
                0.5, // 10
                0.5, // 11
                0.75, // 12
                0.75, // 13
                0.75, // 14
                0.75, // 15
                1, // 16
                1, // 17
                1, // 18
                1, // 19
                1, // 20
                1, // 21
                1, // 22
                1, // 23
                1 // 24 
            ];
            this.scale = this.scales[this.map.getZoom()];
        }

        return instance;
    }

    static getInstance() {
        return instance;
    }

    // возможно надо перенести эту функцию в fort-map
    setObjectsOnMap({ listOfObjects = [], notClusteringZoom = 20, defaultRoutes, selectedObjectId }) {
        this._clearMarkers();
        this.markersLayer = this._createMarkersLayerClusterGroup(notClusteringZoom);
        this.markersLayer = this._constructMarkersLayer({ listOfObjects, defaultRoutes, selectedObjectId });
        if (this.isMarkersVisible) {
            this._addMarkersLayer(this.markersLayer);
        }

        this.markersLayer.on('clusterdblclick', (a) => {
            !this.map.isClickBlocked() && a.layer.zoomToBounds({ padding: [20, 20] });
        });
        this.markersLayer.on('clusterclick', (a) => {
            !this.map.isClickBlocked() && this._showClusterPopup(a);
        });

        this._addEventZoomEndOnMap();
    }

    setMarkersOnMap(listOfObjects = [], notClusteringZoom = 20) {
        this._clearMarkers();
        this.markersLayer = this._createMarkersLayerClusterGroup(notClusteringZoom);
        for (let object of listOfObjects) {
            let marker = new FortMarker(object, this.map, this.scale);
            marker.denyClick();
            this.markersDictionary[marker.object.id] = marker;
            this.markersLayer.addLayer(marker);
        }

        if (this.isMarkersVisible) {
            this._addMarkersLayer(this.markersLayer);
        }

        this._addEventZoomEndOnMap();
    }    

    updateMarkers(listOfObjectsProps) {
        let objectsUpdateCondition = (typeof listOfObjectsProps != 'undefined')
            && listOfObjectsProps.length > 0 && this.markersDictionary != {} && this.markersLayer != null;
        if (objectsUpdateCondition) {
            for (var i = 0; i < listOfObjectsProps.length; i++) {
                let marker = this._getMarkerById(listOfObjectsProps[i].id);
                if (marker == null) continue;
                marker.updateMarker(listOfObjectsProps[i]);
            }
            if (this.isMarkersVisible) {
                this.markersLayer.refreshClusters();
            }
        }
    }

    updateObjects(listOfObjectsProps) {
        let objectsUpdateCondition = (typeof listOfObjectsProps != 'undefined')
            && listOfObjectsProps.length > 0 && this.markersDictionary != {} && this.markersLayer != null;
        if (objectsUpdateCondition) {
            for (var i = 0; i < listOfObjectsProps.length; i++) {
                let marker = this._getMarkerById(listOfObjectsProps[i].oid);
                if (marker == null) continue;
                marker.updateMarker(listOfObjectsProps[i]);
            }
            if (this.isMarkersVisible) {
                this.markersLayer.refreshClusters();
            }
        }
    }

    _addEventZoomEndOnMap () {
        this.map.on('zoomend', (event) => {
            this.scale = this.scales[this.map.getZoom()];
            let oldScale = this.scales[this.curZoom];

            if (this.scale != oldScale) {
                this.markersLayer.eachLayer((marker) => {
                    marker.scale = this.scale;
                    marker._tooltip.options.offset.y = 25 * this.scale;

                    // Так работало раньше, на всякий случай пусть будет.
                    // var icon = marker.options.icon;
                    // let newwidth = this.scale * marker.object.obj_icon_width;
                    // let newheight = this.scale * marker.object.obj_icon_height;
                    // icon.options.iconSize = [newwidth, newheight];
                    // icon.options.iconAnchor = [
                    //     marker._getIconWidth(marker.object.obj_icon_width) * this.scale / 2,
                    //     marker._getIconHeight(marker.object.obj_icon_height) * this.scale / 2
                    // ],
                    // marker.setIcon(marker._getObjectIcon(icon));
                    marker.setIcon(marker._getObjectIcon(marker.object));
                    marker.updateLabelMarkup();
                });
            }
            this.curZoom = this.map.getZoom();
        });
    }

    _showClusterPopup(cluster) {
        this._hideClusterPopup();

        let childs = cluster.layer.getAllChildMarkers();
        let childsForPopup = childs;
        let footerMsg = '';
        let latLng = cluster.latlng;

        this.clusterPopup = new ClusterPopup('', childsForPopup, latLng, this.map);
    }

    _hideClusterPopup() {
        if (this.clusterPopup != null)
            this.map.closePopup();
    }

    _clearMarkers() {
        for (const key of Object.keys(this.markersDictionary)) {
            const marker = this.markersDictionary[key];
            marker.clearEventListeners();
        }
        if (this.markersLayer != null) {
            this._removeMarkersLayer(this.markersLayer);
            this.markersDictionary = {};
        }
    }

    setMarkersVisibility = () => {
        if (this.isMarkersVisible) {
            this._removeMarkersLayer(this.markersLayer);
        }
        else {
            this._addMarkersLayer();
            this.markersLayer.refreshClusters();
        }
        this.isMarkersVisible = !this.isMarkersVisible;
        return this.isMarkersVisible;
    }

    _addMarkersLayer() {
        this.map.addLayer(this.markersLayer);
    }

    _removeMarkersLayer(layer) {
        if (this.map.hasLayer(layer)) this.map.removeLayer(layer);
    }

    _constructMarkersLayer({ listOfObjects, defaultRoutes, selectedObjectId }) {
        for (let object of listOfObjects) {
            let objectDrawCondition = object.IsGroup != null && object.IsGroup == false && object.real_id > 0;
            if (objectDrawCondition) {
                let objectRoute = defaultRoutes.find(route => route.route.oid == object.real_id);
                let marker = new FortMarker({
                    ...object,
                    routeColor: objectRoute && objectRoute.color,
                    selected: object.real_id == selectedObjectId,
                }, this.map, this.scale);
                this.markersDictionary[marker.object.real_id] = marker;
                this.markersLayer.addLayer(marker);
            }
        }

        return this.markersLayer;
    }

    _createMarker(markerDrawConfig, position) {
        let marker = new L.Marker(position, markerDrawConfig);
        marker.bindTooltip(markerDrawConfig.labelMarkup.standartLabel, { permanent: true }).openTooltip();
        marker.on('mouseover', this._onOverObjectLabel);
        marker.on('mouseout', this._onOutObjectLabel);
        return marker;
    }

    _getMarkerById(id) {
        return this.markersDictionary[id];
    }

    getMarkerObjectById(id) {
        return this.markersDictionary[id].object;
    }

    _getIconForCluster(cluster) {
        var childs = cluster.getAllChildMarkers();
        var status = 5;
        for (var i = 0; i < childs.length; i++) {
            if (status > childs[i].status) status = childs[i].status;
            if (status == 1) break; //уже самое критичное, дальше можно не смотреть
        }
        if (status == 0) status = 5;
        var color = 'green';
        switch (status) {
            case 1: color = 'red'; break;
            case 2: color = 'orange'; break;
            case 3: color = 'yellow'; break;
            case 4: color = 'blue'; break;
        }
        return new L.DivIcon({
            html: '<span>' + childs.length + '</span>',
            className: 'marker-cluster marker-cluster-' + color,
            iconSize: new L.Point(40, 40)
        });
    }

    _createMarkersLayerClusterGroup(notClusteringZoom) {
        return new L.markerClusterGroup({
            disableClusteringAtZoom: notClusteringZoom, animate: false, zoomToBoundsOnClick: false,
            iconCreateFunction: (cluster) => {
                return this._getIconForCluster(cluster);
            },
            clusterPane: 'objectsPane',
        });
    }

    getObjectInfo() { }

    getObjectMarkerById() { }

    setMapOnMarker(oid) {
        if (oid && this.markersDictionary[oid]) {
            this.selectedMarker = oid;
            let latLng = this.markersDictionary[oid].getLatLng();

            this.map.panTo(new L.LatLng(latLng.lat, latLng.lng));
        }
    }
}
